import iconIMG from '../../assets/Logo/slides.png';
import styles from './SplashScreen.module.css';

const SplashScreen = ({ className = '', exiting = false }) => (
  <div
    className={[styles.overlay, exiting && styles.exiting, className].filter(Boolean).join(' ')}
    role="status"
    aria-busy="true"
    aria-live="polite"
  >
    <div className={styles.stack}>
      <div className={styles.badge}>
        <img src={iconIMG} alt="" className={styles.badgeLogo} />
      </div>

      <div className={styles.canvas}>
        <div className={`${styles.node} ${styles.layoutBox}`} />
        <div className={`${styles.cursor} ${styles.cursorLayout}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#5b8dd6"><path d="M4 3l16 8-7 2-2 7z" /></svg>
        </div>

        <div className={`${styles.node} ${styles.imageBox}`}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#e2716b" strokeWidth="1.8"><circle cx="8" cy="9" r="2" /><path d="M3 18l6-6 4 4 5-5 3 3" /></svg>
        </div>
        <div className={`${styles.cursor} ${styles.cursorImage}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#e2716b"><path d="M4 3l16 8-7 2-2 7z" /></svg>
        </div>

        <div className={`${styles.node} ${styles.shapeBox}`} />
        <div className={`${styles.cursor} ${styles.cursorShape}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#3aa76d"><path d="M4 3l16 8-7 2-2 7z" /></svg>
        </div>

        <div className={`${styles.node} ${styles.textBox}`}>
          <span className={styles.word1}>Great</span>
          <span className={styles.word2}>idea!</span>
          <span className={styles.caret} />
        </div>
        <div className={`${styles.cursor} ${styles.cursorText}`}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#8a6ec4"><path d="M4 3l16 8-7 2-2 7z" /></svg>
        </div>
      </div>

      <div className={styles.wordmark}>
        <div className={styles.title}>Slides</div>
        <div className={styles.dots}>
          <span className={styles.dot} style={{ animationDelay: '0s' }} />
          <span className={styles.dot} style={{ animationDelay: '.15s' }} />
          <span className={styles.dot} style={{ animationDelay: '.3s' }} />
        </div>
      </div>
    </div>
  </div>
);

export default SplashScreen;
